/*
 *
 * CoursesMobile constants
 *
 */

export const FLUSH_STATE = 'app/CoursesMobile/FLUSH_STATE';

export const LOAD_COURSES = 'app/CoursesMobile/LOAD_COURSES';
export const LOAD_COURSES_SUCCESS = 'app/CoursesMobile/LOAD_COURSES_SUCCESS';
export const LOAD_COURSES_ERROR = 'app/CoursesMobile/LOAD_COURSES_ERROR';

export const UPDATE_COURSE = 'app/CoursesMobile/UPDATE_COURSE';
export const UPDATE_COURSE_SUCCESS = 'app/CoursesMobile/UPDATE_COURSE_SUCCESS';
export const UPDATE_COURSE_ERROR = 'app/CoursesMobile/UPDATE_COURSE_ERROR';
